/**
 * 页面曝光埋点配置
 * @author haoru
 */

import { ENUM_ROLE } from '@/schemas/common';
import { DOCTOR_JOBTYPE } from '@/schemas/doctor';
import { getCookie } from '@/utils/cookies';

const pvRoutes = {
  '/': {
    pageID: 'KWAI_HEALTHY_HOME_PAGE'
  },
  '/doctors': {
    pageID: 'KWAI_HEALTHY_SEEK_CONSULTING'
  },
  '/doctors/:doctor_id': {
    pageID: 'KWAI_HEALTHY_DOCTOR_DETAIL',
    pageParams: {
      user_id: getCookie('ud')
    },
    matchedRegx: { doctor_id: '[0-9a-z]+' }
  },
  '/order/create/:doctor_id/0': {
    pageID: 'KWAI_HEALTHY_IMAGE_CONSULT',
    pageParams: {
      user_id: getCookie('ud')
    },
    matchedRegx: { doctor_id: '[0-9a-z]+' }
  },
  '/order/create/:doctor_id/1': {
    pageID: 'KWAI_HEALTHY_PHONE_CONSULT',
    pageParams: {
      user_id: getCookie('ud')
    },
    matchedRegx: { doctor_id: '[0-9a-z]+' }
  },
  '/order/create/:doctor_id/6': {
    pageID: 'KWAI_HEALTHY_QUICK_CONSULT',
    pageParams: {
      user_id: getCookie('ud')
    },
    matchedRegx: { doctor_id: '[0-9a-z]+' }
  },
  '/order/register-create/:doctor_id': {
    pageID: 'REGISTER_MESSAGE_EDIT',
    matchedRegx: { doctor_id: '[0-9a-z]+' }
  },
  '/order/pay': {
    pageID: 'KWAI_HEALTHY_DOCTOR_CONSULTATION_ORDER'
  },
  '/covid-19/testing': {
    pageID: 'KWAI_HEALTHY_NUCLEIC_TEST'
  },
  '/covid-19/store/:storeId': {
    pageID: 'KWAI_HEALTHY_NUCLEIC_TEST_DETAIL',
    matchedRegx: { storeId: '[0-9a-z]+' }
  },
  '/order/covid-19/:storeId/create': {
    pageID: 'KWAI_HEALTHY_NUCLEIC_TEST_PAYMENT',
    matchedRegx: { storeId: '[0-9a-z]+' }
  },
  '/covid-19/activity': {
    pageID: 'KWAI_HEALTHY_NUCLEIC_TEST_ACTIVITY'
  },
  '/doctor-workstation': {
    pageID: 'KWAI_HEALTHY_WORKBENCH',
    pageParams: {
      user_id: getCookie('ud')
    },
    funcs: {
      user_type: () => {
        // 这里的jobType只允许用来做埋点逻辑，不允许用来做任何业务逻辑
        const jobType = Number(sessionStorage.getItem('jobType'));
        if (jobType === DOCTOR_JOBTYPE.ASSISTANT) {
          return ENUM_ROLE.PRESCRIPTION;
        }
        if (
          jobType === DOCTOR_JOBTYPE.FULLTIME ||
          jobType === DOCTOR_JOBTYPE.PARTTIME
        ) {
          return ENUM_ROLE.DOCTOR;
        }
        // 进入页面时，尚未调用getUserInfo，导致无法判断jobType
        return ENUM_ROLE.PATIENT;
      }
    }
  },
  '/order/records': {
    pageID: 'KWAI_HEALTHY_MY_ORDER',
    funcs: {
      user_type: () => {
        // 这里的jobType只允许用来做埋点逻辑，不允许用来做任何业务逻辑
        const jobType = Number(sessionStorage.getItem('jobType'));
        if (jobType === DOCTOR_JOBTYPE.ASSISTANT) {
          return ENUM_ROLE.PRESCRIPTION;
        }
        if (
          jobType === DOCTOR_JOBTYPE.FULLTIME ||
          jobType === DOCTOR_JOBTYPE.PARTTIME
        ) {
          return ENUM_ROLE.DOCTOR;
        }
        // 进入页面时，尚未调用getUserInfo，导致无法判断jobType
        return ENUM_ROLE.PATIENT;
      }
    }
  },
  '/order/doctor-records': {
    pageID: 'KWAI_HEALTHY_MY_ORDER',
    funcs: {
      user_type: () => {
        // 这里的jobType只允许用来做埋点逻辑，不允许用来做任何业务逻辑
        const jobType = Number(sessionStorage.getItem('jobType'));
        if (jobType === DOCTOR_JOBTYPE.ASSISTANT) {
          return ENUM_ROLE.PRESCRIPTION;
        }
        if (
          jobType === DOCTOR_JOBTYPE.FULLTIME ||
          jobType === DOCTOR_JOBTYPE.PARTTIME
        ) {
          return ENUM_ROLE.DOCTOR;
        }
        // 进入页面时，尚未调用getUserInfo，导致无法判断jobType
        return ENUM_ROLE.PATIENT;
      }
    }
  },
  '/doctor-profile/:doctor_id': {
    pageID: 'KWAI_HEALTHY_MY',
    matchedRegx: { doctor_id: '[0-9a-z]+' }
  },
  '/setting': {
    pageID: 'KWAI_HEALTHY_SET'
  },
  '/register/home': {
    pageID: 'APPOINTMENT_REGISTER_HOME_PAGE'
  },
  '/register/search/hospital': {
    pageID: 'APPOINTMENT_HOSPITAL_LANDING'
  },
  '/register/search/department': {
    pageID: 'APPOINTMENT_DEPARTMENT_LANDING'
  },
  '/register/v2/department/:hospital_id/:department_id': {
    pageID: 'APPOINTMENT_DEPARTMENT_DOCTOR',
    matchedRegx: {
      hospital_id: '[0-9a-z]+',
      department_id: '[0-9a-z]+'
    }
  },
  '/register/v2/departments/': {
    pageID: 'APPOINTMENT_DEPARTMENT_DOCTOR'
  },
  '/register/hospital/:hospital_id': {
    pageID: 'KWAI_HEALTHY_APPOINTMENT_REGISTER',
    matchedRegx: {
      hospital_id: '[0-9a-z]+'
    }
  },
  '/register/department/:hospital_id/:department_id': {
    pageID: 'KWAI_HEALTHY_DOCTOR_LIST',
    matchedRegx: {
      hospital_id: '[0-9a-z]+',
      department_id: '[0-9a-z]+'
    }
  },
  '/order/register-detail/:order_id': {
    pageID: 'REGISTER_ORDER',
    matchedRegx: { order_id: '[0-9a-z]+' }
  },
  '/order/detail/:order_id': {
    pageID: 'REGISTER_ORDER',
    matchedRegx: { order_id: '[0-9a-z]+' }
  },
  '/order/doctor-detail/:orderId': {
    pageID: 'REGISTER_ORDER',
    matchedRegx: { order_id: '[0-9a-z]+' }
  },
  '/user-satisfaction-survey': {
    pageID: 'REGISTER_PROCESS_EXPERIENCE'
  },
  '/daily-baike': {
    pageID: 'EVERYDAY_POPULAR_SCIENCE'
  },
  '/healthy-channel/daily-baike-share': {
    pageID: 'EVERYDAY_SCIENCE_SHARE'
  },
  '/quick-consult/create': {
    pageID: 'HEALTHY_QUICK_CONSULT'
  },
  '/survey/list/:department_id': {
    pageID: 'HEALTH_SELF_TEST_LIST',
    matchedRegx: {
      department_id: '[0-9a-z]+'
    }
  },
  '/survey/detail/:evaluation_id': {
    pageID: 'HEALTH_SELF_TEST',
    matchedRegx: {
      evaluation_id: '[0-9a-z]+'
    }
  },
  '/survey/question/:evaluation_id': {
    pageID: 'EVALUATION_DETAIL_ANSWER',
    matchedRegx: {
      evaluation_id: '[0-9a-z]+'
    }
  },
  '/survey/report/:evaluation_id': {
    pageID: 'EVALUATION_RESULT',
    pageParams: {
      category: 'SELF'
    },
    matchedRegx: {
      evaluation_id: '[0-9a-z]+'
    }
  },
  '/survey/records': {
    pageID: 'HEALTH_SELF_TEST_RECORD'
  },
  '/lives': {
    pageID: 'KWAI_HEALTHY_LIVE'
  },
  '/skin-detection': {
    pageID: 'PHOTOGRAPH_SKIN_LANDING'
  },
  'skin-detection/upload-image': {
    pageID: 'SKIN_MESSAGE_CONFIRM'
  },
  'skin-detection/questions': {
    pageID: 'EVALUATION_FILL_INFORMATION'
  },
  'skin-detection/user-info': {
    pageID: 'PERSONAL_INFORMATION_COLLECTION'
  },
  '/skin-detection/report': {
    pageID: 'EVALUATION_RESULT',
    pageParams: {
      category: 'SKIN'
    }
  },
  '/order/quick-consult': {
    pageID: 'KWAI_HEALTHY_TRIAGE_ORDER'
  },
  '/vaccination': {
    pageID: 'VACCINE_INOCULATION_POINT_QUERY'
  },
  '/disease/history/info/:orderId': {
    pageID: 'MEDICAL_HISTORY_INFORMATION_FILLING',
    matchedRegx: {
      orderId: '[0-9a-z]+'
    }
  },
  '/med/shop/select/:id': {
    pageID: 'SELECT_MERCHANT',
    matchedRegx: {
      id: '[0-9a-z]+'
    }
  },
  '/med/shop/select/otc/:id': {
    pageID: 'SELECT_MERCHANT',
    matchedRegx: {
      id: '[0-9a-z]+'
    }
  },
  '/prescription/create/:order_id': {
    pageID: 'ADVANCE_OPEN_PRESCRIPTION',
    matchedRegx: {
      order_id: '[0-9a-z]+'
    }
  },
  '/prescription/update/:order_id/:prescription_id': {
    pageID: 'ADVANCE_OPEN_PRESCRIPTION',
    matchedRegx: {
      order_id: '[0-9a-z]+',
      prescription_id: '[0-9a-z]+'
    }
  },
  '/prescription/create/:order_id/:prescription_id': {
    pageID: 'ADVANCE_OPEN_PRESCRIPTION',
    matchedRegx: {
      order_id: '[0-9a-z]+',
      prescription_id: '[0-9a-z]+'
    }
  },
  '/med/detail/:drug_id/:shop_id/:source': {
    pageID: 'PRESCRIPTION_PRODUCT_DETAILS_PAGE',
    matchedRegx: {
      drug_id: '[0-9a-z]+',
      shop_id: '[0-9a-z]+',
      source: '[0-9a-z]+'
    }
  },
  '/med/addr/list': {
    pageID: 'MY_RECEIPT_ADDRESS_MANAGE'
  },
  '/prescription/preview/:id': {
    pageID: 'ADVANCE_OPEN_PRESCRIPTION_PREVIEW',
    matchedRegx: {
      id: '[0-9a-z]+'
    }
  },
  '/prescription/detail/:id': {
    pageID: 'PRESCRIPTION_DETAIL',
    matchedRegx: {
      id: '[0-9a-z]+'
    }
  },
  '/feedback/question-detail/:question_id': {
    pageID: 'HEALTHY_PROBLEM_SOLVING_DETAIL',
    matchedRegx: {
      question_id: '[0-9a-z]+'
    }
  },
  '/med/outsite/:encodeUrl': {
    pageID: 'THIRD_PARTY_JUMP',
    matchedRegx: {
      encodeUrl: '[\\S]+'
    }
  },
  '/doctor-apply': {
    pageID: 'OPEN_SERVICE_INTRODUCTION'
  },
  'doctor-apply-form': {
    pageID: 'OPEN_SERVICE_FORM_FILLING'
  },
  '/med/doctor/advise/:order_id': {
    pageID: 'PRESCRIPTION_COMMODITY_PROPOSAL',
    matchedRegx: {
      order_id: '[0-9a-z]+'
    }
  },
  '/med/user/cart/:advise_id': {
    pageID: 'PRESCRIPTION_SHOPPING_CART',
    matchedRegx: {
      advise_id: '[0-9a-z]+'
    }
  },
  '/med/doctor/shop/select/:order_id': {
    pageID: 'HEALTHY_SELECT_STORE',
    matchedRegx: {
      order_id: '[0-9a-z]+'
    }
  },
  '/med/doctor/kuai/:order_id': {
    pageID: 'KWAI_STORE_COMMODITY',
    matchedRegx: {
      order_id: '[0-9a-z]+'
    }
  },
  '/med/doctor/prescribe-doctors': {
    pageID: 'PRESCRIPTION_MEDICAL_BIND_LIST'
  },
  '/dermatological-center': {
    pageID: 'SKIN_SPECIALIST_CENTER_LANDING'
  },
  '/dermatological-center/dermatological-answer-detail/:unique': {
    pageID: 'HOT_TOPIC_DETAIL',
    matchedRegx: {
      unique: '[a-z]+'
    }
  },
  '/dermatological-activity': {
    pageID: 'ACTIVITY_SKIN_SPECIALIST_CENTER'
  },
  '/consult-info-collect': {
    pageID: 'PRIVATE_INQUIRY_INFORMATION_COLLECTION'
  },
  '/doctor-list': {
    pageID: 'MEDICAL_CONSULTATION_DOCTOR_LIST'
  },
  '/andrology-center': {
    pageID: 'ANDROLOGY_CENTER_LANDING'
  },
  '/consult/summary/detail/:order_id': {
    pageID: 'CONSULT_SERVICE_SUMMARY_DETAIL',
    matchedRegx: {
      order_id: '[0-9a-z]+'
    }
  },
  '/consult/doctor/summary/create/:orderId': {
    pageID: 'FILL_CONSULT_SERVICE_SUMMARY',
    matchedRegx: {
      order_id: '[0-9a-z]+'
    }
  },
  '/doctor-workstation-message': {
    pageID: 'HEALTHY_MESSAGE'
  },
  '/doctor-workstation/main-message-manage': {
    pageID: 'MESSAGE_MANAGEMENT'
  },
  '/download/video': {
    pageID: 'SAFARI_DOWNLOAD'
  },
  '/med-dictionary': {
    pageID: 'KS_MEDEICAL_CLASSIC'
  },
  '/med-dictionary-search': {
    pageID: 'KS_MEDEICAL_CLASSIC_SEARCH'
  },
  'doctor-visit-info': {
    pageID: 'DOCTOR_INFO_PAGE'
  }
};

export default pvRoutes;
